<template>
	<div class="messageList">
		<div v-if="messageList.length > 0" class="messageList_content">
			<div
				v-for="(message, index) of messageList"
				:key="index"
				class="messageBox"
			>
				<infoItem :message="message" />

				<div class="btn_box">
					<el-button
						v-if="message.actionUrl === '/versions/index'"
						type="text"
						@click="viewDetail"
					>
						版本详情
					</el-button>
				</div>
			</div>
		</div>
		<div v-else class="noMessage">暂无消息</div>
		<el-pagination
			background
			layout="prev, pager, next"
			:page-size="10"
			:total="total"
			@current-change="requestMessageCenterListAll"
			hide-on-single-page
		>
		</el-pagination>
	</div>
</template>

<script>
import infoItem from "@/components/Information/infoItem";
export default {
	name: "messageList",
	components: {
		infoItem,
	},
	props: {
		messageType: {
			type: String,
		},
	},
	data() {
		return {
			total: 0,
			messageList: [],
		};
	},
	mounted() {
		this.requestMessageCenterListAll(1);
	},
	methods: {
		requestMessageCenterListAll(currentPage) {
			let params = {
				pageNumber: currentPage,
				pageSize: 10,
			};
			let query = "?" + new URLSearchParams(params).toString();
			let data = {
				type: this.messageType,
			};
			this.$api.messageCenterListAll(query, data).then((res) => {
				if (res.errcode != 0) return false;
				this.messageList = res.data;
				this.total = parseInt(res.total);
			});
		},
		viewDetail() {
			window.open(
				"https://majorel.feishu.cn/docs/doccndcskpHUXqhj9uARenTNhLf",
				"target"
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.messageList {
	height: 100%;
	.messageList_content {
		height: calc(100% - 40px);
		overflow: scroll;
		&::-webkit-scrollbar { 
			width: 10px; // 横向滚动条
 		 	height: 10px; // 纵向滚动条 必写
		}
	}
	.messageBox {
		padding: 10px 20px;
		border-radius: 8px;
		border: 1px solid hsla(0, 0%, 85%, 1);
	}
	.messageBox + .messageBox {
		margin-top: 10px;
	}
	.noMessage {
		color: gray;
		height: calc(100% - 40px);
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
.btn_box {
	display: flex;
	justify-content: right;
}
</style>